// FLAGS: none
// The five locale codes the app ships UI for, and the post-sign-in i18next switch that falls back to
// en-GB for anything else.
import i18n from "i18next";

export const OpenupCultureCookieName = "openup_culture";
export const LanguageCodeDutchNl = "nl-NL";
export const LanguageCodeEnglishGb = "en-GB";
export const LanguageCodeGermanDe = "de-DE";
export const LanguageCodeFrenchFr = "fr-FR";
export const LanguageCodeSpanishEs = "es-ES";

export const changeLanguageAfterSignin = (languageCode) => {
  switch (languageCode) {
    case LanguageCodeDutchNl:
    case LanguageCodeFrenchFr:
    case LanguageCodeEnglishGb:
    case LanguageCodeGermanDe:
    case LanguageCodeSpanishEs:
      i18n.changeLanguage(languageCode);
      break;
    default:
      i18n.changeLanguage(LanguageCodeEnglishGb);
      break;
  }
};
